import React, { ReactNode } from "react";
import { Dialog, Theme, StandardProps } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "../../typescript";
import TableHead, { TableHeadProps } from "@material-ui/core/TableHead";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            color: theme.palette.grey["600"],
            backgroundColor: theme.palette.grey["200"],
            "& span:hover": {
                color: theme.palette.grey["600"]
            }
        }
    });

type AppTableHeadClassKey = StyleClassKey<typeof styles>;

const useStyles = makeStyles(styles);

export interface AppTableHeadProps
    extends StandardProps<TableHeadProps, AppTableHeadClassKey> {
    children: ReactNode;
}

function Component(props: AppTableHeadProps) {
    const classes = useStyles(props);
    return (
        <TableHead {...props} className={classes.root} classes={classes}>
            {props.children}
        </TableHead>
    );
}

Component.displayName = "AppTableHead";
export const AppTableHead = Component;
export default AppTableHead;
